import { DefaultWidgetGetDto, LocationWidgetSettingsGetDto, LocationWithDefaultWidgetGetDto, WidgetGetDto } from "clearline-api";
import { CampaignSettings } from ".";

/** @deprecated use LocationWithDefaultWidgetGetDto instead */
export class LocationWithDefaultWidget implements LocationWithDefaultWidgetGetDto {
  public icon: string;
  public overrided: boolean;
  public isOutOfThePlan: boolean;
  public defaultWidgetSettings: DefaultWidgetGetDto;
  public campaignSettings: CampaignSettings;
  public locationWidgetSettings: LocationWidgetSettingsGetDto;
  public description: string;
  public isEditing: boolean;
  public widget: WidgetGetDto;
}
